import React, { FC } from 'react';
import Styled from './styled';
import { CategoryAnnouncement, RowAnnouncement, SectorAnnouncement } from './Announcement';
import {
  GroupedAnnouncements,
  ICategoryAnnouncement,
  IRowAnnouncement,
  ISectorAnnouncement,
} from '../../../types/announcements';
import { ANNOUNCEMENTS_TYPE, SORT_ON } from '../../../constants/ANNOUNCEMENT';
import useTranslate from '../../../hooks/useTranslate';

type TAnnouncementsFC = FC<{
  selectedFilter: string;
  announcements: GroupedAnnouncements;
  selectedSubFilter: string;
  sortOn: string;
}>;

const Announcements: TAnnouncementsFC = (props) => {
  const { selectedFilter, selectedSubFilter, sortOn, announcements } = props;
  const { t } = useTranslate();
  const { announcementsController } = window.Widget;

  const {
    isSelectAllSubFilter: isSelectAllSectorSubFilter,
    isOtherSelected: isOtherSectorSelected,
    announcementsData: sectorAnnouncements,
    isSelectAllFilter: isSelectAllFilterForSector,
  } = announcementsController.getFilterAnnouncements(
    ANNOUNCEMENTS_TYPE.SECTOR,
    selectedFilter,
    selectedSubFilter,
    sortOn,
  );

  const {
    isSelectAllSubFilter: isCategoryAllSelected,
    isOtherSelected: isOtherCategorySelected,
    announcementsData: categoryAnnouncements,
    isSelectAllFilter: isSelectAllFilterForCategory,
  } = announcementsController.getFilterAnnouncements(
    ANNOUNCEMENTS_TYPE.CATEGORY,
    selectedFilter,
    selectedSubFilter,
    sortOn,
  );

  return (
    <Styled.Container>
      <Styled.MainContent>
        {(isCategoryAllSelected || isOtherCategorySelected || isSelectAllFilterForCategory) &&
          categoryAnnouncements && (
            <Styled.Section>
              {isSelectAllFilterForCategory && (
                <Styled.SectionTitle>{t('announcements_categories')}</Styled.SectionTitle>
              )}

              <ul>
                {categoryAnnouncements.map((announcement: ICategoryAnnouncement) => {
                  return (
                    <li key={announcement.id}>
                      <CategoryAnnouncement announcement={announcement} />
                    </li>
                  );
                })}
              </ul>
            </Styled.Section>
          )}

        {(isSelectAllSectorSubFilter || isOtherSectorSelected || isSelectAllFilterForSector) &&
          sectorAnnouncements && (
            <>
              <Styled.Section>
                {isSelectAllFilterForSector && (
                  <Styled.SectionTitle>{t('announcements_sectors')}</Styled.SectionTitle>
                )}
                <ul>
                  {sectorAnnouncements.map((announcement: ISectorAnnouncement) => {
                    return (
                      <li key={announcement.id}>
                        <SectorAnnouncement announcement={announcement} />
                      </li>
                    );
                  })}
                </ul>
              </Styled.Section>
              {announcements?.ROW && (
                <Styled.Section>
                  <Styled.SectionTitle>{t('announcements_rows')}</Styled.SectionTitle>
                  <ul>
                    {announcements.ROW.sort((a, b) => {
                      if (sortOn === SORT_ON.ASC) {
                        return a.price - b.price;
                      } else if (sortOn === SORT_ON.DESC) {
                        return b.price - a.price;
                      }
                      return 0;
                    }).map((announcement: IRowAnnouncement) => (
                      <li key={announcement.id}>
                        <RowAnnouncement announcement={announcement} />
                      </li>
                    ))}
                  </ul>
                </Styled.Section>
              )}
            </>
          )}
      </Styled.MainContent>
    </Styled.Container>
  );
};

export default Announcements;
